import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './pages/Layout';
import Main from './pages/Main';
import Administrators from './pages/Administrators';
import VoteBooths from './pages/VoteBooths';
import Calendar from './pages/Calendar';
import ElectionResults from './pages/ElectionResults';
import DevelopmentProjects from './pages/DevelopmentProjects';
import BoothCommittee from './pages/BoothCommittee';
import Forms from './pages/Forms';
import Events from './pages/Events';

import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/auth/Login';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Layout Wrapper for all routes that need header/footer */}
          <Route element={<Layout />}>
            {/* Main Page - Public */}
            <Route path="/" element={<Main />} />
            
            {/* Protected Routes - Require Authentication */}
            <Route
              path="/administrators"
              element={
                <ProtectedRoute>
                  <Administrators />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/vote_booths"
              element={
                <ProtectedRoute>
                  <VoteBooths />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/booth_committee"
              element={
                <ProtectedRoute>
                  <BoothCommittee />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/calendar"
              element={
                <ProtectedRoute>
                  <Calendar />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/election_results"
              element={
                <ProtectedRoute>
                  <ElectionResults />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/forms"
              element={
                <ProtectedRoute>
                  <Forms />
                </ProtectedRoute>
              }
            />

            <Route
              path="/development_projects"
              element={
                <ProtectedRoute>
                  <DevelopmentProjects />
                </ProtectedRoute>
              }
            />

            <Route
              path="/events"
              element={
                <ProtectedRoute>
                  <Events />
                </ProtectedRoute>
              }
            />
          </Route>
          
          {/* 404 - Not Found */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;